<template>
    <div
      class="stateBar"
      :class="{ native: isNative }"
      :style="{ backgroundColor: bgcolor }"
    ></div>
</template>

<script>
export default {
    name: 'stateBar',
    props: {
        bgcolor: {
            type: String,
            default: 'transparent',
        },
    },
    data() {
        return {
            isNative: false,
        };
    },
    beforeMount() {
        this.isNative =
            window.__NAV_CHROME__ === 'native' ||
            document.documentElement.getAttribute('data-chrome') === 'native';
    },
};
</script>

<style lang="scss" scoped>
.stateBar {
    height: var(--state-bar-height, var(--safe-top, var(--safe-area-top, 0px)));

    &.native {
      height: 0 !important;
    }
}
</style>
